import { getPrefixedThemeFont } from './get-prefixed-theme-value';
export const expandFontTheme = (params) => {
    /**
     * If the input is a string, we're assuming a font value is being passed
     * that matches a font key that exists in both the theme or darkTheme object.
     * Example: 'body' or 'darkTheme.body', 'titleH1' or 'darkTheme.titleH1', etc.
     */
    let font = 'inherit';
    let textTransform = 'inherit';
    let fontOpticalSizing = '';
    if (typeof params === 'string' && params !== '') {
        font = getPrefixedThemeFont(params).font;
        textTransform = getPrefixedThemeFont(params).textTransform;
        fontOpticalSizing = getPrefixedThemeFont(params).fontOpticalSizing;
    }
    else if (typeof params === 'object') {
        font = params?.font ?? 'inherit';
        textTransform = params?.textTransform ?? 'inherit';
        fontOpticalSizing = params?.fontOpticalSizing ?? '';
    }
    return `
  font: ${font};
  text-transform: ${textTransform};
  ${fontOpticalSizing ? `font-optical-sizing: ${fontOpticalSizing};` : ''}
`;
};
